// Static copy for the invest drawer's Placing Order and Order Confirmed steps.

/** Checklist on the Placing Order screen (Figma 32590:67999). */
export const PLACING_STEPS = [
  'Verifying wallet balance',
  'Securing token allocation',
  'Initiating Client Money transfer',
  'Placing Order',
] as const

export interface NextStep {
  label: string
  description: string
  state: 'completed' | 'active' | 'upcoming'
}

/**
 * "WHAT HAPPENS NEXT" (Figma 32590:69565) — shown when the order response
 * carries no status tracker of its own.
 */
export const DEFAULT_NEXT_STEPS: NextStep[] = [
  {
    label: 'Order Confirmed',
    description: 'Your commitment is secured and funds are locked in escrow.',
    state: 'completed',
  },
  {
    label: 'Awaiting Full Funding',
    description: 'The property must reach 100% funding before the asset is finalized.',
    state: 'active',
  },
  {
    label: 'Asset Minting',
    description: 'Digital tokens are minted on-chain and assigned to your vault.',
    state: 'upcoming',
  },
  {
    label: 'Portfolio Updated',
    description: 'Your official certificate of ownership is issued.',
    state: 'upcoming',
  },
]

interface TrackerEntry {
  step: number
  label: string
  description: string
  state: string
}

/**
 * The order's own status tracker as timeline steps: completed entries, then
 * the first open one is "active", the rest upcoming. Falls back to the
 * designed copy when the order carries no tracker.
 */
export const toNextSteps = (tracker: TrackerEntry[]): NextStep[] => {
  if (!tracker.length) return DEFAULT_NEXT_STEPS
  const ordered = [...tracker].sort((left, right) => left.step - right.step)
  const firstOpen = ordered.findIndex((entry) => entry.state !== 'completed')
  return ordered.map((entry, index) => ({
    label: entry.label,
    description: entry.description,
    state: entry.state === 'completed' ? 'completed' : index === firstOpen ? 'active' : 'upcoming',
  }))
}
